var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from "mobx";
import { DateLib } from "@@/Datelib";
import { MessageType } from "@@/Message";
// import { AEvent } from "../../events/AppEvent";
// import { FStore } from "../FileStore";
// import { LStore } from "../LetrStore";
// import { MStore } from "../MessageStore";
import { FileDownloadType } from "@/share/FileRequest";
import { Apphandler } from "@/ipc/MainAppHandler";
import { APPEvent } from "@/events/AppEvents";
import { AdminMessageUIRequest, MessageUIRequestType } from "@/share/Message";
export var DownloadState;
(function (DownloadState) {
    DownloadState[DownloadState["Downloading"] = 0] = "Downloading";
    DownloadState[DownloadState["Downloaded"] = 1] = "Downloaded";
    DownloadState[DownloadState["Error"] = 2] = "Error";
})(DownloadState || (DownloadState = {}));
export class ImageDownloadState {
    constructor(path = "") {
        this.downloadstatus = DownloadState.Downloading;
        this.path = "";
        this.showmodal = false;
        this.progress = 0;
        this.downloadstarted = false;
        makeObservable(this);
        this.path = path;
        if (this.path) {
            this.setDownloadStatus(DownloadState.Downloaded);
        }
    }
    setDownloadStarted(started) {
        this.downloadstarted = started;
    }
    setDownloadStatus(st) {
        this.downloadstatus = st;
    }
    setProgress(pg) {
        this.progress = pg;
    }
    setPath(path) {
        this.path = path;
    }
    setShowModal(show) {
        this.showmodal = show;
    }
}
__decorate([
    observable,
    __metadata("design:type", Number)
], ImageDownloadState.prototype, "downloadstatus", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "path", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "showmodal", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "progress", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ImageDownloadState.prototype, "downloadstarted", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setDownloadStarted", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setDownloadStatus", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setProgress", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setPath", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ImageDownloadState.prototype, "setShowModal", null);
export class AdminMessageUIStore {
    constructor() {
        this.messages = new Map();
        this.messagesBySection = new Map();
        this.loading = false;
        this.activeuserid = "";
        this.activeletrid = "";
        this.initaltime = 956952079000; // maybe better to use server side lgic ?
        this.activeSection = "";
        this.clientwidth = 200;
        this.clientheight = 500;
        this.updatingSection = false;
        this.displaySection = "";
        this.renderedSections = new Set();
        this.lastCount = -1;
        this.replies = [];
        this.loadingReplies = false;
        this.replySliderOpen = false;
        this.imagesstate = new Map();
        this.downloadingfileids = new Map();
        this.messagecoutrequest = 20;
        this.hidesystemmessages = false;
        this.loadingMore = false;
        this.lastMessageTime = 0;
        makeObservable(this);
        // AEvent.addSubscriberForMessages((msg) => msg.forEach(m => this.addMessage(m)));
        // APPEvent.addSubscriberForAdminLetrChanged((letr) => {
        //     this.reset();
        //     this.activeletrid = letr.id;
        //     console.log('loading messages ' + letr.id + " " + letr.letrMetadata.subject);
        //     this.loadMessages();
        // });
        APPEvent.addSubscriberForLetrUserChanged((useird) => {
            this.reset();
            this.activeuserid = useird;
            this.activeletrid = "";
        });
        APPEvent.addSubscriberForAdminTagChanged((tag) => {
            this.reset();
            this.activeletrid = "";
        });
        APPEvent.addSubscriberForAdminDownload((res) => {
            const fileid = this.downloadingfileids.get(res.id);
            if (fileid === undefined) {
                return;
            }
            const istate = this.imagesstate.get(fileid);
            if (istate !== undefined && istate.downloadstatus === DownloadState.Downloading
                &&
                    res.requesttype === FileDownloadType.Download) {
                if (res.downloadpath !== undefined) {
                    const msg = this.getMessageById(fileid);
                    if (msg !== undefined && msg.type === MessageType.Image) {
                        let prefix = "data:image/png;base64,";
                        const name = msg.text;
                        if (name.indexOf(".") > 0) {
                            const ext = name.split('.').pop();
                            if (ext !== undefined) {
                                if (ext.toLowerCase() === 'jpg') {
                                    prefix = "data:image/jpg;base64,";
                                }
                                else if (ext.toLowerCase() === 'jpeg') {
                                    prefix = "data:image/jpeg;base64,";
                                }
                                else if (ext.toLowerCase() === 'gif') {
                                    prefix = "data:image/gif;base64,";
                                }
                                else if (ext.toLowerCase() === 'giff') {
                                    prefix = "data:image/giff;base64,";
                                }
                            }
                        }
                        res.downloadpath = prefix + res.downloadpath;
                    }
                    istate.setPath(res.downloadpath);
                    istate.setDownloadStatus(DownloadState.Downloaded);
                    istate.setDownloadStarted(false);
                }
                else if (res.downloadfailed) {
                    istate.setDownloadStatus(DownloadState.Error);
                    istate.setDownloadStarted(false);
                }
            }
        });
        // APPEvent.addSubscriberForAdminMessageResponse((msg) => {
        //         this.setLoading(false);
        //         this.setLoadingMore(false);
        //         if (msg.msg.length < this.messagecoutrequest) {
        //             this.setLastCount(0);
        //         }
        //         msg.msg.forEach(m => this.addMessage(m));
        //     }
        // );
        APPEvent.addSubscriberForAdminMessageResponse((res) => {
            const msg = res.msg;
            const letrid = res.letrid;
            if (letrid === this.activeletrid) {
                if (res.type === MessageUIRequestType.Fetch) {
                    if (msg.length < this.messagecoutrequest) {
                        this.setLastCount(0);
                    }
                    this.addMessage(msg);
                    this.setLoading(false);
                    this.setLoadingMore(false);
                }
            }
        });
    }
    setHideSystemMessahe(hide) {
        this.hidesystemmessages = hide;
    }
    getActiveLetrId() {
        return this.activeletrid;
    }
    downloadImage(msg) {
        // lets download the image here and then we done for today!!
        const req = {
            letrid: this.activeletrid,
            id: msg.documentreference,
            requesttype: FileDownloadType.Download,
            size: msg.size,
            info: {
                name: "letrwing"
            },
            accesskey: msg.accesskey,
            boxid: msg.accesscode,
            userid: this.activeuserid
        };
        this.downloadingfileids.set(msg.documentreference, msg._id);
        Apphandler.sendMessage("admindownloadfile", req);
    }
    setLoadingMore(lm) {
        this.loadingMore = lm;
    }
    setLastCount(count) {
        this.lastCount = count;
    }
    setLoadingReplies(loading) {
        this.loadingReplies = loading;
    }
    async loadReplies(msg) {
        if (this.loadingReplies) {
            return;
        }
        this.setLoadingReplies(true);
        // const replies = await MStore.getMessageReplies(this.activeletrid, msg._id, this.activeuserid);
        // this.setReplies(replies);
        if (this.loadingMore || this.loading || this.lastCount === 0) {
            return;
        }
        const req = new AdminMessageUIRequest();
        req.letrid = this.activeletrid;
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.time = this.lastMessageTime;
        req.type = MessageUIRequestType.FetchReplies;
        req.userid = this.activeuserid;
        this.requestMessages(req);
    }
    getActiveUserId() {
        return this.activeuserid;
    }
    setReplies(replies) {
        this.replies = replies.sort(this.sortMessage);
    }
    getMessage(index) {
        return this.getMessages()[index];
    }
    getMessageById(id) {
        return this.messages.get(id);
    }
    setClientWidth(width) {
        this.clientwidth = width;
    }
    setClientHeight(height) {
        this.clientheight = height;
    }
    setDisplaySection(section) {
        this.displaySection = section;
    }
    // @action
    // public async loadMessages() {
    //     if(!this.activeletrid || this.loading || (this.lastCount === 0)) {
    //         return;
    //     }
    //     this.setLoading(true);
    //     const lmessage = this.findLastMessage();
    //     const time = lmessage?.createdAt??this.initaltime;
    //     const ignoreids = lmessage?._id??undefined;
    //     this.lastCount = await MStore.getNMessageForTag(this.activeuserid, this.activeletrid, time, 
    //     20, LStore.getPasswordKeyForLetr(this.activeletrid), ignoreids? [ignoreids]: undefined);
    //     this.setLoading(false);
    // }
    async loadMessages() {
        if (!this.activeletrid || this.loading || (this.lastCount === 0)) {
            return;
        }
        this.setLoading(true);
        const req = new AdminMessageUIRequest();
        req.letrid = this.activeletrid;
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.type = MessageUIRequestType.Fetch;
        if (this.hidesystemmessages) {
            req.excludetype.push(MessageType.Project);
        }
        req.time = new Date().getTime() + 60 * 60 * 24 * 1000;
        req.userid = this.activeuserid;
        this.requestMessages(req);
    }
    loadMore() {
        if (this.loadingMore || this.loading || this.lastCount === 0) {
            return;
        }
        this.setLoadingMore(true);
        const req = new AdminMessageUIRequest();
        req.letrid = this.activeletrid;
        req.count = this.messagecoutrequest;
        req.sortAsc = false;
        req.time = this.lastMessageTime;
        req.type = MessageUIRequestType.Fetch;
        if (this.hidesystemmessages) {
            req.excludetype.push(MessageType.Project);
        }
        req.userid = this.activeuserid;
        this.requestMessages(req);
    }
    requestMessages(req) {
        Apphandler.sendMessage("adminmessages", req);
    }
    setLoading(loading) {
        this.loading = loading;
    }
    addMessage(bmsgs) {
        var _a;
        for (const bmsg of bmsgs) {
            this.messages.set(bmsg._id, bmsg);
            const date = DateLib.getTodayOrFormatDate(bmsg.createdAt);
            if (!this.messagesBySection.has(date)) {
                this.messagesBySection.set(date, []);
            }
            (_a = this.messagesBySection.get(date)) === null || _a === void 0 ? void 0 : _a.push(bmsg);
            if (this.lastMessageTime === 0 || bmsg.createdAt < this.lastMessageTime) {
                this.lastMessageTime = bmsg.createdAt;
            }
        }
    }
    getSections() {
        return this.messagesBySection;
    }
    getMessages() {
        return Array.from(this.messages.values()).sort(this.sortMessage);
    }
    getMessageSection(msg) {
        return DateLib.getTodayOrFormatDate(msg.createdAt);
    }
    getMessageTime(msg) {
        return DateLib.displayTime(msg.createdAt);
    }
    getMessageDateTime(msg) {
        return DateLib.displayDate(msg.createdAt);
    }
    reset() {
        this.messages = new Map();
        this.messagesBySection = new Map();
        this.activeSection = "";
        this.updatingSection = false;
        this.setDisplaySection("");
        this.renderedSections = new Set();
        this.lastCount = -1;
    }
    findLastMessage() {
        const msg = this.getMessages();
        if (msg.length === 0) {
            return undefined;
        }
        return msg[msg.length - 1];
    }
    sortMessage(m1, m2) {
        return m1.createdAt - m2.createdAt;
    }
    setMainMessage(mainMessage) {
        this.mainMessage = mainMessage;
    }
    setReplySliderOpen(open) {
        this.replySliderOpen = open;
    }
}
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminMessageUIStore.prototype, "messages", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], AdminMessageUIStore.prototype, "messagesBySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "clientwidth", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "clientheight", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "displaySection", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], AdminMessageUIStore.prototype, "replies", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "loadingReplies", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "mainMessage", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "replySliderOpen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "hidesystemmessages", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], AdminMessageUIStore.prototype, "loadingMore", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setHideSystemMessahe", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setLoadingMore", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setLastCount", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setLoadingReplies", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setReplies", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setClientWidth", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setClientHeight", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setDisplaySection", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], AdminMessageUIStore.prototype, "loadMessages", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "addMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "reset", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setMainMessage", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], AdminMessageUIStore.prototype, "setReplySliderOpen", null);
